export enum referralTypes  {
  GET_MY_REFERRALS_DETAILS_REQUEST_SUCCESS = 'GET_MY_REFERRALS_REQUEST_SUCCESS',


  GET_REFERRAL_CODE_REQUEST_SUCCESS = 'GET_REFERRAL_CODE_REQUEST_SUCCESS',
}
